import {
  BaseNode,
  LabelNode,
  StandardApprovalFlowNode,
} from './components/node-components';
import { NewConditionNode } from './components/node-components/NewConditionNode';

export const nodeTypes = {
  labelNode: LabelNode,
  baseNode: BaseNode,
  standardApprovalFlowNode: StandardApprovalFlowNode,
  newConditionNode: NewConditionNode,
};
